import { useTheme } from "@acdc2/ui/components/theme-provider";
import { mdiThemeLightDark } from "@mdi/js";
import { useTranslation } from "react-i18next";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@acdc2/ui/components/dropdown-menu";
import { NavbarButtonIcon } from "./NavbarButtonIcon";
import { NavbarButton } from "./NavbarButton";

export function ViewerThemeNavbarButton() {
  const { t } = useTranslation();
  const { setTheme, theme } = useTheme();

  const onValueChange = (value: string) => {
    if (value === "dark" || value === "light" || value === "system") {
      setTheme(value);
    } else {
      console.error("Invalid theme value");
    }
  };

  return (
    <DropdownMenu>
      <NavbarButton tooltip={t("ViewerThemeNavbarButton.title")}>
        <DropdownMenuTrigger asChild>
          <NavbarButtonIcon path={mdiThemeLightDark} />
        </DropdownMenuTrigger>
      </NavbarButton>
      <DropdownMenuContent
        className="my-2"
        side="right"
        onCloseAutoFocus={(e) => e.preventDefault()}
      >
        <DropdownMenuLabel children={t("ViewerThemeNavbarButton.title")} />
        <DropdownMenuSeparator />
        <DropdownMenuRadioGroup value={theme} onValueChange={onValueChange}>
          <DropdownMenuRadioItem
            value="light"
            children={t("ViewerThemeNavbarButton.items.light")}
          />
          <DropdownMenuRadioItem
            value="dark"
            children={t("ViewerThemeNavbarButton.items.dark")}
          />
          <DropdownMenuRadioItem
            value="system"
            children={t("ViewerThemeNavbarButton.items.system")}
          />
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
